<div class="chart" #chartRef></div>
